import { render, staticRenderFns } from "./JourneyBuilderIndex.vue?vue&type=template&id=37b79eda&scoped=true&"
import script from "./JourneyBuilderIndex.vue?vue&type=script&lang=js&"
export * from "./JourneyBuilderIndex.vue?vue&type=script&lang=js&"
import style0 from "../Style/journey-builder-index.scss?vue&type=style&index=0&id=37b79eda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b79eda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37b79eda')) {
      api.createRecord('37b79eda', component.options)
    } else {
      api.reload('37b79eda', component.options)
    }
    module.hot.accept("./JourneyBuilderIndex.vue?vue&type=template&id=37b79eda&scoped=true&", function () {
      api.rerender('37b79eda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/JourneyBuilderIndex.vue"
export default component.exports